import { Injectable } from '@angular/core';
import {CanLoad, Router} from '@angular/router';
import {StorageService} from '../services/storage.service';

@Injectable({
  providedIn: 'root'
})
export class LanguageGuard implements CanLoad {

  constructor(
    private storageService: StorageService,
    private router: Router
  ) {}

  async canLoad() {
    const lng = await this.storageService.language();
    if (lng !== null && (lng === 'de' || lng === 'en')) {
      return true;
    } else {
      this.router.navigate(['/language'], {replaceUrl: true}).then();
      return false;
    }
  }
}
